<template>
  <div class="channel_content">
    <div class="l">
      <div class="title">您的智能关务管家</div>
      <div class="subtitle"><span>O-TECH</span>自由贸易协定优惠关税查询系统</div>
      <div class="desc">中美加征速查、关税税率查询、原产地规则查询、税则查询、检验检疫要求及贸易监管单证查询</div>
      <div class="btns">
        <div class="slogon">立即节税，注册即享</div>
        <div class="btn" @click.prevent="$router.push('/')" v-if="isLogin">去体验</div>
        <div class="btn" @click.prevent="isShow(true)" v-else>登录/注册</div>
      </div>
    </div>
    <img src="~@/assets/images/channel/image.png" class="r">
  </div>
</template>

<script>
import Vue from 'vue'
import { mapMutations, createNamespacedHelpers } from 'vuex'
const { mapState: mapAccountState } = createNamespacedHelpers('account')

export default {
  name: 'ChannelContentZH',
  props: ['code'],
  mounted () {
    this.$nextTick(() => {
      if (this.code) {
        Vue._h.storage.local.set('cc', this.code)
      }
    })
  },
  computed: {
    isLogin () {
      return !this._.isEmpty(this.userInfo) && this.userInfo.token
    },
    ...mapAccountState({
      userInfo: state => state.userInfo
    })
  },
  methods: {
    ...mapMutations({
      isShow: 'account/setModalState'
    })
  }
}
</script>
<style scoped>
  /*.channel_content{*/
    /*position: relative;*/
  /*}*/
  .channel_content .l{
    width: 480px;
    position: absolute;
    top: 50%;
    left: 12.5%;
    transform: translateY(-50%);
  }
  .channel_content .title{
    font-size: 16px;
    color: #1F8AFD;
    margin-bottom: 15px;
    font-weight: bold;
  }
  .channel_content .subtitle{
    font-size: 14px;
    color: #333;
    margin-bottom: 25px;
    font-weight: bold;
  }
  .channel_content .subtitle span{
    color: #1F8AFD;
    padding-right: 10px;
  }
  .channel_content .desc{
    font-size: 14px;
    color: #999;
    line-height: 24px;
    width: 420px;
  }
  .channel_content .btns{
    border-top: 1px solid #E9E9E9;
    margin-top: 20px;
    padding-top: 20px;
  }
  .channel_content .btns .slogon{
    font-size: 13px;
    color: #666;
  }
  .channel_content .btns .btn{
    background-image: linear-gradient(90deg, #42BEFF 9%, #1F8AFD 100%);
    border-radius: 100px;
    width: 150px;
    text-align: center;
    height: 36px;
    line-height: 36px;
    margin-top: 15px;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
  }
  img.r{
    position: absolute;
    width: 360px;
    top: 50%;
    right: 10%;
    transform: translateY(-50%);
  }
</style>



// WEBPACK FOOTER //
// src/components/channel/zh-CN/Content.vue